export enum RelativeDate {
  NextWeek = 'Next Week',
  NextMonth = 'Next Month',
  NextQuarter = 'Next Quarter',
  NextYear = 'Next Year'
}
